import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
	selector: 'warning-modal',
	standalone: true,
	imports: [
		CommonModule
	],
	templateUrl: './warningmodal.component.html',
	styleUrl: './warningmodal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningModalComponent {
	constructor() {

	}

	public showDialog$: Subject<boolean> = new BehaviorSubject<boolean>(false);

	public resultModel$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

	public show(resultModel) {
		this.resultModel$.next(resultModel);
		this.showDialog$.next(true);
	}

	public close(): void {
		this.showDialog$.next(false);
	}

	public download() {
		const a = <any>document.getElementById('linkanchor');
		const file = new Blob([this.resultModel$.value.warningReport], { type: 'text/plain' });
		a.href = URL.createObjectURL(file);
		a.download = 'warningReport.txt';
		a.dispatchEvent(new MouseEvent('click'));
	}
}
